export const CPF_MASK = '999.999.999-99';
export const CNPJ_MASK = '99.999.999/9999-99';
export const CEP_MASK = '99999-999';
export const PHONE_MASK = '(99) 99999-9999';
